module.exports = __webpack_public_path__ + "static/media/QRcodeVersar-playStore.203e091e.svg";